exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".actionsHeader-b4120{display:flex;align-items:center}.buttonMargin-c4556{margin-right:24px}", ""]);

// Exports
exports.locals = {
	"actionsHeader": "actionsHeader-b4120",
	"buttonMargin": "buttonMargin-c4556"
};